import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WallpaperService } from '../../services/wallpaper.service';
import { SearchWallpaper, buildPdpUrl } from '../../models/wallpaper.model';

@Component({
  selector: 'app-similar-dialog',
  templateUrl: './similar-dialog.component.html'
})
export class SimilarDialogComponent implements OnInit {
  similarItems: SearchWallpaper[] = [];
  loading = true;
  wallpaperName = '';
  wallpaperSlug = '';

  constructor(
    private route: ActivatedRoute,
    private wallpaperService: WallpaperService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.wallpaperSlug = params['slug'] || '';
    });
    this.route.queryParams.subscribe(qp => {
      this.wallpaperName = qp['name'] || this.wallpaperSlug.replace(/-/g, ' ');
      const keywords = qp['keywords'] || '';
      const collection = qp['collection'] || '';
      const category = qp['category'] || '';
      this.loadSimilar(keywords || this.wallpaperName, collection, category);
    });
  }

  private loadSimilar(searchText: string, collection: string, category: string) {
    this.loading = true;
    this.similarItems = [];

    // 1. Search by keywords first
    this.wallpaperService.searchWallpapers({
      searchtext: searchText,
      page: 1,
      images: 12,
    }).subscribe({
      next: (res) => {
        // Filter out the source wallpaper itself
        const results = (res.results || [])
          .filter((w: SearchWallpaper) => w.slug !== this.wallpaperSlug)
          .slice(0, 10);
        if (results.length >= 4) {
          this.similarItems = results;
          this.loading = false;
        } else if (category) {
          // Not enough keyword results, try category
          this.loadByCategory(category, results);
        } else if (collection) {
          this.loadByCategory(collection, results);
        } else {
          this.similarItems = results;
          this.loading = false;
        }
      },
      error: () => {
        if (category) this.loadByCategory(category, []);
        else if (collection) this.loadByCategory(collection, []);
        else this.loading = false;
      }
    });
  }

  private loadByCategory(categoryId: string, existingItems: SearchWallpaper[]) {
    this.wallpaperService.searchWallpapers({
      category: categoryId,
      page: 1,
      images: 12,
      sortby: 'id',
      sortdir: 'desc',
    }).subscribe({
      next: (res) => {
        const catResults = (res.results || [])
          .filter((w: SearchWallpaper) => w.slug !== this.wallpaperSlug);
        // Merge: keyword results first, then fill with category results (no duplicates)
        const existingIds = new Set(existingItems.map(w => w.id));
        const merged = [...existingItems];
        for (const w of catResults) {
          if (!existingIds.has(w.id) && merged.length < 10) {
            merged.push(w);
            existingIds.add(w.id);
          }
        }
        this.similarItems = merged;
        this.loading = false;
      },
      error: () => {
        this.similarItems = existingItems;
        this.loading = false;
      }
    });
  }

  openPDP(wp: SearchWallpaper) {
    // Open PDP in the parent/opener window, then close this popup
    const url = buildPdpUrl(wp);
    if (window.opener) {
      window.opener.location.href = url;
      window.close();
    } else {
      window.location.href = url;
    }
  }

  closeWindow() {
    window.close();
  }
}
